import React from 'react'

import { Link as RouterLink } from 'react-router-dom'

import {
  IconButton,
} from '@mui/material'

import ChevronRightIcon from '@mui/icons-material/ChevronRight'

import { DataGrid, esES } from '@mui/x-data-grid'

const PreceptorsTable = (props) => {
  const { rows } = props

  const columns = [
    // { field: 'id', headerName: 'ID', width: 70 },
    { 
      field: 'name', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Nombre'}</b>
      ),
      renderCell: (params) => (
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <b>{params.value}</b>
        </span>
      ),
      minWidth: 220,
      flex: 2,
      hideable: false,
    },
    { 
      field: 'email', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Email'}</b>
      ), 
      minWidth: 220,
      flex: 2,
    },
    { 
      field: 'id',
      headerName: '',
      flex: 0,
      renderCell: (params) => (
        <IconButton component={RouterLink} to={`${params.value}`}>
          <ChevronRightIcon />
        </IconButton>
      ),
      type: 'singleSelect',
      align: 'right',
      sortable: false,
      filterable: false,
      hideable: false,
    },
  ]

  return (
    <DataGrid
      autoHeight
      disableSelectionOnClick
      // disableColumnMenu
      columns={columns}
      localeText={esES.components.MuiDataGrid.defaultProps.localeText}
      pageSize={10}
      rows={rows}
      rowsPerPageOptions={[10]}
      sx={{ borderWidth: 0 }}
    />
  )
}

export default PreceptorsTable